<div class="modal-header">
    <h5 class="modal-title">Temporarily reassign crew member</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
    <div class="mb-3">
        <label class="form-label">Crew member</label>
        <div>{{ context.memberName }}</div>
    </div>

    <div class="mb-3">
        <label class="form-label">From foreman</label>
        <div>{{ context.fromForemanName }}</div>
    </div>

    <div class="mb-3">
        <label class="form-label" for="reassign-to-foreman">To foreman</label>
        <select id="reassign-to-foreman" class="form-select" [ngModel]="toForemanHrRef()" (ngModelChange)="toForemanHrRef.set($event)">
            <option [ngValue]="0">Select foreman…</option>
            @for (foreman of targetForemen(); track foreman.hrRef) {
                <option [ngValue]="foreman.hrRef">{{ foreman.name }} — {{ foreman.jobTitle }}</option>
            }
        </select>
    </div>

    <div class="row g-3">
        <div class="col-md-6">
            <label class="form-label" for="reassign-start-date">Start date</label>
            <input
                id="reassign-start-date"
                type="date"
                class="form-control"
                [ngModel]="startDate()"
                (ngModelChange)="startDate.set($event)"
            />
        </div>
        <div class="col-md-6">
            <label class="form-label" for="reassign-end-date">End date</label>
            <input
                id="reassign-end-date"
                type="date"
                class="form-control"
                [ngModel]="endDate()"
                (ngModelChange)="endDate.set($event)"
            />
        </div>
    </div>

    @if (error()) {
        <p class="text-danger mt-3 mb-0">{{ error() }}</p>
    }
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="save()">Save reassignment</button>
</div>
